import {
    ActiviteCompteBancaireDtoInput,
    ActiviteCompteBancaireModelDto,
    ArrayOfActiviteCompteBancaireDtoInput,
    ArrayOfFpaSectionAnalytiqueModelDtoInput,
    ArrayOfMoyenPaiementActiviteDtoInput,
    CeDelegationDtoInput,
    CommissionDtoInput,
    ComptabiliteEpargnesActiviteModelInput,
    CompteDto,
    CompteDtoInput,
    CompteurPointAfpaModelInput,
    CriteresActiviteDtoInput,
    EnveloppeQuotaDtoInput,
    FichierModelInput,
    FpaSectionAnalytiqueModelDtoInput,
    JournalDtoInput,
    JournalTypeDtoInput,
    ModeleEnveloppeDto,
    ModeleRegleAccModelDto,
    ModeleRegleSubQuotaModeleDto,
    ModeleSauvegardeAfpadtoInput,
    MoyenPaiementActiviteDtoInput,
    PlanWithSectionsAnalytiquesModelInput,
    PointVenteDtoInput,
    SaveActiviteModelDtoInput,
    StatusDtoEnum,
    TypeActiviteDtoInput
} from 'src/graphql/generated-types';
import { arrayEmpty, arrayNotEmpty } from 'src/app/utils/array.utils';
import { getXmlBoolean, getXmlLine } from 'src/app/utils/soap.utils';
import { guid } from 'src/app/utils/guid.utils';
import {
    ActiviteNormalize
} from 'src/app/board/activity/activity-shared/activity-generals-settings/activity-activities-settings/classes/activity-activities-settings-page';
import {
    mediaLibrariesRulesModelToXML,
    mediaLibrariesSubQuotaRuleToXML,
    sharedResourcesQuotaRuleToXML
} from 'src/app/board/activity/activity-shared/activity-settings/activity-media-catalog/activity-media-catalog.xml';
import { TypeActivite } from 'src/app/board/activity/activity.constants';
import {
    catalogRulesModelToXml
} from 'src/app/board/activity/activity-shared/activity-settings/activity-catalog/activity-catalog.xml';
import {
    advancedRuleFPAToXML
} from 'src/app/_shared/services/advanced-rule/advanced-rule.xml';
import cloneDeep from 'lodash-es/cloneDeep';

export function settingsActivityXml(model: ModeleSauvegardeAfpadtoInput): string {
    return `<modele xmlns:d4p1="http://schemas.datacontract.org/2004/07/V2DTO"
                    xmlns:dto="http://schemas.datacontract.org/2004/07/V2DTO"
                    xmlns:arrayElement="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
                    xmlns:i="http://www.w3.org/2001/XMLSchema-instance"
                    xmlns:z="http://schemas.microsoft.com/2003/10/Serialization/">
                <d4p1:Status>INSERTED</d4p1:Status>
                ${modeleAffichageRegleXml(model)}
                ${modeleSaveActiviteXml(model.ModeleSaveActivite)}
                ${getRule(model)}
            </modele>`;
}

function getRule(model: ModeleSauvegardeAfpadtoInput): string {
    switch (model.ModeleSaveActivite.Activite.TypeActivite.Code) {
        case TypeActivite.Mediatheque:
            return mediaLibrariesRulesModelToXML(model.ModeleSaveReglesAFPA, mediaLibrariesSubQuotaRuleToXML);
        case TypeActivite.Pret:
            return catalogRulesModelToXml(model.ModeleSaveReglesAFPA);
        case TypeActivite.RessourcesPartagees:
            return mediaLibrariesRulesModelToXML(model.ModeleSaveReglesAFPA, sharedResourcesQuotaRuleToXML);
        case TypeActivite.Epargnes:
            return '';
        default:
            return '';
    }
}

function modeleSaveActiviteXml(model: SaveActiviteModelDtoInput): string {
    const activity: ActiviteNormalize = model.Activite as ActiviteNormalize;
    return `<d4p1:ModeleSaveActivite>
                <d4p1:Status>INSERTED</d4p1:Status>
                ${activiteXml(activity)}
                ${comptabiliteEpargnesXml(model.ComptabiliteEpargnes)}
                ${critereSaveActiviteXml(model.CritereSaveActivite)}
                ${listeActiviteCompteBancaireModelXml(model.ListeActiviteCompteBancaireModel?.ActiviteCompteBancaireModelDTO)}
                ${listeSectionAnalytiqueXml(model.ListeActiviteFraisPortAchatSectionAnalytique, 'ListeActiviteFraisPortAchatSectionAnalytique')}
                ${listeSectionAnalytiqueXml(model.ListeActiviteFraisPortVenteSectionAnalytique, 'ListeActiviteFraisPortVenteSectionAnalytique')}
                ${listeSectionAnalytiqueXml(model.ListeActiviteTropPercuSectionAnalytique, 'ListeActiviteTropPercuSectionAnalytique')}
                ${getXmlBoolean(model, 'RedescendreFactureCentraliseSurTsProduit', {defaultValue: false})}
            </d4p1:ModeleSaveActivite>`;
}

function modeleAffichageRegleXml(model: ModeleSauvegardeAfpadtoInput): string {
    const ModeleAffichageRegle = model.ModeleAffichageRegle;
    const ruleList = ModeleAffichageRegle?.ListeModeleRegleLocale?.MoteurRegleModelDTO;

    return ModeleAffichageRegle || arrayNotEmpty(ruleList)
        ?`
        <d4p1:ModeleAffichageRegle>
            <d4p1:Status>INSERTED</d4p1:Status>
            <d4p1:ListeModeleRegleAfaireHerite></d4p1:ListeModeleRegleAfaireHerite>
            <d4p1:ListeModeleRegleLocale>
            ${(arrayNotEmpty(ruleList) ? ruleList : [])?.map(rule => {
            return `
                    <d4p1:MoteurRegleModelDTO>
                        ${getXmlLine(rule, 'Status')}
                        ${rule.EnveloppeModele ? getEnveloppeRule(rule.EnveloppeModele) : ''}
                        ${getXmlLine(rule, 'Id', {defaultValue: 0})}
                        ${getXmlLine(rule, 'IdEnveloppe')}
                        ${getXmlBoolean(rule, 'IsCloture', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsComplementaire', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsForcageAutorise', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsModifiableRegle', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsRegleAvancee', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsRegleNiveauUn', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsRegleUse', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsRglBudget', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsSansSubventionAudelaLimite', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsSubChoisie', {defaultValue: false})}
                        ${getXmlBoolean(rule, 'IsTransverse', {defaultValue: false})}
                        ${getXmlLine(rule, 'LibelleRegle')}
                        <d4p1:ListeIdRglUseAct i:nil="true" xmlns:d8p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRglUseAct>
                        <d4p1:ListeIdRglUseArt i:nil="true" xmlns:d8p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRglUseArt>
                        <d4p1:ListeIdRglUseFam i:nil="true" xmlns:d8p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRglUseFam>
                        <d4p1:ListeIdRglUsePrd i:nil="true" xmlns:d8p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRglUsePrd>
                        <d4p1:ListeIdRgleHerAct i:nil="true" xmlns:d8p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRgleHerAct>
                        <d4p1:ListeIdRgleHerFam i:nil="true" xmlns:d8p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRgleHerFam>
                        <d4p1:ListeIdRgleHerPrd i:nil="true" xmlns:d8p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdRgleHerPrd>
                        ${advancedRuleFPAToXML(rule.RegleAvancee)}
                        ${getAccessibilityRule(rule.ModeleRegleAcc)}
                        ${getSubventionRule(rule.ModeleRegleSubQta)}
                        ${getXmlLine(rule, 'TypeRegle')}
                        ${getXmlLine(rule, 'TypeValeurLimite')}
                    </d4p1:MoteurRegleModelDTO>
                `;
        }).join('')}
            </d4p1:ListeModeleRegleLocale>
            ${getComplementaryRule(ModeleAffichageRegle)}
          </d4p1:ModeleAffichageRegle>
    `: '';
}

export function getAccessibilityRule(rule: ModeleRegleAccModelDto): string {
    if (!rule) {
        return '';
    }

    return `
        <d4p1:ModeleRegleAcc>
            ${getXmlLine(rule, 'Status')}
            ${getXmlLine(rule, 'AgeEnfantMax', {defaultValue: null})}
            ${getXmlLine(rule, 'AgeEnfantMin', {defaultValue: null})}
            ${getXmlLine(rule, 'DateRefJour', {defaultValue: null})}
            ${getXmlLine(rule, 'DateRefJourAgeEnf', {defaultValue: null})}
            ${getXmlLine(rule, 'DateRefMois', {defaultValue: null})}
            ${getXmlLine(rule, 'DateRefMoisAgeEnf', {defaultValue: null})}
            ${getXmlLine(rule, 'Id', {defaultValue: 0})}
            ${getXmlLine(rule, 'IdChampAD')}
            ${getXmlLine(rule, 'IdChamp')}
            ${getXmlLine(rule, 'IdTypeDateRefAge')}
            ${getXmlLine(rule, 'IdtypeRefAnc')}
            ${getXmlBoolean(rule, 'IsConjointHandicape', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsEnfantACharge', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsEnfantDirect', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsEnfantHandicape', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsForcageAutorise', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsNominative', {defaultValue: false})}
            ${arrayNotEmpty(rule.ListeIdChampAD?.decimal) ? `
                <d4p1:ListeIdChampAD>
                    ${rule.ListeIdChampAD.decimal.map(e => {
                        return `<d9p1:decimal xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">${e}</d9p1:decimal>`;
                    }).join('')}
                </d4p1:ListeIdChampAD>
            ` : ''}
            ${arrayNotEmpty(rule.ListeIdTypeBenef?.decimal) ? `
                <d4p1:ListeIdTypeBenef>
                    ${rule.ListeIdTypeBenef.decimal.map(e => {
                        return `<d9p1:decimal xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">${e}</d9p1:decimal>`;
                    }).join('')}
                </d4p1:ListeIdTypeBenef>
            ` : ''}
            <d4p1:ListeModeleRegleAccListeModele>
                ${(arrayNotEmpty(rule?.ListeModeleRegleAccListeModele?.RegleAccListeValModelDTO) ? rule?.ListeModeleRegleAccListeModele?.RegleAccListeValModelDTO : [])?.map(e => {
        return `
                    <d4p1:RegleAccListeValModelDTO>
                        <d4p1:Status>INSERTED</d4p1:Status>
                        ${getXmlLine(e, 'Status')}
                        ${getXmlLine(e, 'AncienneteMaximum')}
                        ${getXmlLine(e, 'AncienneteMinimum')}
                        ${getXmlLine(e, 'Id')}
                        ${getXmlLine(e, 'IdValeurChamp')}
                    </d4p1:RegleAccListeValModelDTO>
                    `;
    }).join('')}
            </d4p1:ListeModeleRegleAccListeModele>
            ${getXmlLine(rule, 'ModeAccess')}
            ${getXmlLine(rule, 'RgModAccesAnMax')}
            ${getXmlLine(rule, 'RgModAccesAnMin')}
        </d4p1:ModeleRegleAcc>
    `;
}

export function getSubventionRule(rule: ModeleRegleSubQuotaModeleDto): string {
    if (!rule) {
        return '';
    }

    return `
        <d4p1:ModeleRegleSubQta>
            ${getXmlLine(rule, 'Status', {defaultValue: rule.Id ? StatusDtoEnum.Updated : StatusDtoEnum.Inserted})}
            ${getXmlLine(rule, 'DateRefPondJour', {defaultValue: null})}
            ${getXmlLine(rule, 'DateRefPondMois', {defaultValue: null})}
            ${getXmlLine(rule, 'Id', {defaultValue: 0})}
            ${getXmlLine(rule, 'IdChamp')}
            ${getXmlLine(rule, 'IdPeriodeNbDossier')}
            ${getXmlLine(rule, 'IdTypeDateRefPond')}
            ${getXmlBoolean(rule, 'IsForcageAutorise', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsNominatif', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsPondererMoisEntier', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsPondererMoisPresence', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsPondererTempsTravail', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsPourChaqueOD', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsSansSubventionAudelaLimite', {defaultValue: false})}
            <d4p1:ListeModeleRegleSubQuotaValModele>
            ${(arrayNotEmpty(rule.ListeModeleRegleSubQuotaValModele?.RegleSubQuotaListeValModelDTO) ? rule.ListeModeleRegleSubQuotaValModele?.RegleSubQuotaListeValModelDTO : [])?.map(e => {
        return `
                    <d4p1:RegleSubQuotaListeValModelDTO>
                        ${getXmlLine(e, 'Status', {defaultValue: e.Id ? StatusDtoEnum.Updated : StatusDtoEnum.Inserted})}
                        ${getXmlLine(e, 'A')}
                        ${getXmlLine(e, 'De')}
                        ${getXmlLine(e, 'ChpLstValId')}
                        ${getXmlLine(e, 'Conjoint')}
                        ${getXmlLine(e, 'Enfant')}
                        ${getXmlLine(e, 'Externe')}
                        ${getXmlLine(e, 'Id', {defaultValue: 0})}
                        ${getXmlLine(e, 'Od')}
                        ${getXmlLine(e, 'TypeVal')}
                        ${getXmlLine(e, 'ValMax')}
                        ${getXmlLine(e, 'ValMin')}
                    </d4p1:RegleSubQuotaListeValModelDTO>
                `;
    }).join('')}
            </d4p1:ListeModeleRegleSubQuotaValModele>
            ${getXmlLine(rule, 'ModeSimple', {defaultValue: false})}
            ${getXmlLine(rule, 'RgModSQTypeVal')}
            ${getXmlLine(rule, 'RglModeleIdAgeEnfMax')}
            ${getXmlLine(rule, 'RglModeleIdAgeEnfMin')}
            ${getXmlLine(rule, 'RglModeleIdEnfAch', {defaultValue: false})}
            ${getXmlLine(rule, 'RglModeleIdEnfDir', {defaultValue: false})}
            ${getXmlLine(rule, 'RglModeleIdEnfHan', {defaultValue: false})}
            ${getXmlLine(rule, 'RglModeleSQMontant')}
            ${getXmlLine(rule, 'RglModeleSQTypeRegle')}
            ${getXmlLine(rule, 'ValeurSubParDefaut')}
        </d4p1:ModeleRegleSubQta>
    `;
}

function getComplementaryRule(rule): string {
    return `
        <d4p1:ListeReglesComplementaires>
            ${(arrayNotEmpty(rule?.ListeReglesComplementaires?.RegleComplementaireModelDTO) ? rule.ListeReglesComplementaires.RegleComplementaireModelDTO : [])?.map(e => {
        return `
                    <d4p1:RegleComplementaireModelDTO>
                        ${getXmlLine(e, 'Status', {defaultValue: rule.Id ? StatusDtoEnum.Updated : StatusDtoEnum.Inserted})}
                        ${getXmlLine(e, 'Id')}
                        ${getXmlLine(e, 'IdEnveloppe')}
                        ${getXmlBoolean(e, 'IsHeritee', {defaultValue: false})}
                        ${getXmlBoolean(e, 'IsSelected', {defaultValue: false})}
                        ${getXmlLine(e, 'Libelle')}
                        ${getXmlLine(e, 'MontantSubvention')}
                        ${getXmlLine(e, 'Ordre')}
                        ${getXmlLine(e, 'PourcentageSubvention')}
                        ${advancedRuleFPAToXML(e.RegleAvancee)}
                    </d4p1:RegleComplementaireModelDTO>
                `;
    }).join('')}
        </d4p1:ListeReglesComplementaires>
    `;
}

function getEnveloppeRule(rule: ModeleEnveloppeDto): string {
    return `
        <d4p1:EnveloppeModele>
            ${getXmlLine(rule, 'Code')}
            ${getXmlLine(rule, 'Id')}
            ${getXmlLine(rule, 'IdModeleRglLim', {defaultValue: 0})}
            ${getXmlLine(rule, 'IdMoteurRegle', {defaultValue: 0})}
            ${getXmlBoolean(rule, 'IsAfficheEnLigne', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsCloture', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsComplementaire', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsEnvAttribution', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsHerite', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsNominatif', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsPeriodeCycle', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsPeriodeUnique', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsSansPeriode', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsSubChoisie', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsSynchroKalidea', {defaultValue: false})}
            ${getXmlBoolean(rule, 'IsTransverse', {defaultValue: false})}
            ${getXmlBoolean(rule, 'Libelle')}
            <d4p1:ListeIdEnvImpAct i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdEnvImpAct>
            <d4p1:ListeIdEnvImpArt i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdEnvImpArt>
            <d4p1:ListeIdEnvImpFam i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdEnvImpFam>
            <d4p1:ListeIdEnvImpPrd i:nil="true" xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays"></d4p1:ListeIdEnvImpPrd>
        </d4p1:EnveloppeModele>
    `;
}

function listeCEDelegationXml(ListeCEDelegation: CeDelegationDtoInput[], CEDelegationProprietaire: CeDelegationDtoInput): string {
    const list = (ListeCEDelegation: CeDelegationDtoInput[]): string => {
        return ListeCEDelegation.map(ce => {
            if (ce.Id === CEDelegationProprietaire.Id) {
                return `<d4p1:CEDelegationDTO z:Ref="icedelegation${ce.Id}"></d4p1:CEDelegationDTO>`;
            }
            return `<d4p1:CEDelegationDTO>
                ${getXmlLine(ce, 'CECodl')}
                ${getXmlBoolean(ce, 'CEIdCclo', {defaultValue: false})}
                ${getXmlBoolean(ce, 'CEIdcGlob', {defaultValue: false})}
                ${getXmlLine(ce, 'CENom')}
                ${getXmlLine(ce, 'Id')}
            </d4p1:CEDelegationDTO>`;
        }).join('');
    };

    return arrayEmpty(ListeCEDelegation) ? ''
        : `<d4p1:ListeCEDelegation> ${list(ListeCEDelegation)} </d4p1:ListeCEDelegation>`;
}

function comptabiliteEpargnesXml(ComptabiliteEpargnes: ComptabiliteEpargnesActiviteModelInput): string {
    const sectionList = (sectionList): string => {
        const list = (sectionList): string => {
            return sectionList.map((s) => {
                return `<d9p1:anyType i:type="d4p1:SectionAnalytiqueBaseModel">
                          ${getXmlLine(s, 'IdSection')}
                          ${getXmlLine(s, 'IdSectionPere')}
                          ${getXmlLine(s, 'IsClos', {defaultValue: 0})}
                          ${getXmlLine(s, 'LibelleSection')}
                          ${getXmlLine(s, 'NiveauSection')}
                        </d9p1:anyType>`;
            }).join('');
        };

        return arrayEmpty(sectionList) ? ''
            : `<d4p1:ListeSection xmlns:d9p1="http://schemas.microsoft.com/2003/10/Serialization/Arrays">${list(sectionList)}</d4p1:ListeSection>`;
    };

    const listePlanSectionAnalytiqueXml = (planList: PlanWithSectionsAnalytiquesModelInput[]): string => {
        const list = (planlist): string => {
            return planlist.map(section => {
                return `<d4p1:PlanWithSectionsAnalytiquesModel>
                        <d4p1:Status>INSERTED</d4p1:Status>
                        ${getXmlLine(section, 'IdPlan')}
                        ${getXmlLine(section, 'IdSectionAnalytique')}
                        ${getXmlLine(section, 'LibellePlan')}
                        ${sectionList(section.ListeSection?.anyType)}
                   </d4p1:PlanWithSectionsAnalytiquesModel>`;
            }).join('');
        };

        return arrayEmpty(planList) ? ''
            : `<d4p1:ListePlanSectionAnalytique>${list(planList)}</d4p1:ListePlanSectionAnalytique>`;
    };

    return !ComptabiliteEpargnes ? ''
        : `<d4p1:ComptabiliteEpargnes>
                  <d4p1:Status>INSERTED</d4p1:Status>
                  ${getXmlLine(ComptabiliteEpargnes, 'IdCollectifAttente')}
                  ${getXmlLine(ComptabiliteEpargnes, 'IdCollectifPMV')}
                  ${getXmlLine(ComptabiliteEpargnes, 'IdCompteBancaireEpargne')}
                  ${getXmlLine(ComptabiliteEpargnes, 'IdCompteChargeAbondement')}
                  ${getXmlLine(ComptabiliteEpargnes, 'IdJournalAbondement')}
                  ${getXmlLine(ComptabiliteEpargnes, 'IdJournalEpargne')}
                  ${getXmlLine(ComptabiliteEpargnes, 'IdJournalPMV')}
                  ${listePlanSectionAnalytiqueXml(ComptabiliteEpargnes.ListePlanSectionAnalytique?.PlanWithSectionsAnalytiquesModel)}
            </d4p1:ComptabiliteEpargnes>`;
}

function listeActiviteCompteBancaireModelXml(ListeActiviteCompteBancaireModel: ActiviteCompteBancaireModelDto[]): string {
    const list = (ListeActiviteCompteBancaireModel: ActiviteCompteBancaireModelDto[]): string => {
        return ListeActiviteCompteBancaireModel.map((item) => {
            return `<d4p1:ActiviteCompteBancaireModelDTO>
                        ${getXmlLine(item, 'Status', {defaultValue: StatusDtoEnum.Inserted})}
                        ${getXmlLine(item, 'IdActivite', {defaultValue: 0})}
                        ${getXmlLine(item, 'IdActiviteCompteBancaireType')}
                        ${getXmlLine(item, 'IdCompteBancaire')}
                        ${getXmlLine(item, 'IdDelegation')}
                    </d4p1:ActiviteCompteBancaireModelDTO>`;
        }).join('');
    };

    return arrayEmpty(ListeActiviteCompteBancaireModel) ? ''
        : `<d4p1:ListeActiviteCompteBancaireModel>${list(ListeActiviteCompteBancaireModel)}</d4p1:ListeActiviteCompteBancaireModel>`;
}

function listeSectionAnalytiqueXml(ListeSectionAnalytique: ArrayOfFpaSectionAnalytiqueModelDtoInput, parentTagName: string, tagNameDto = 'FPASectionAnalytiqueModelDTO'): string {
    const list = (ListeSectionAnalytique: FpaSectionAnalytiqueModelDtoInput[]): string => {
        return ListeSectionAnalytique.map((el) => {
            return `<d4p1:${tagNameDto}>
                        ${getXmlLine(el, 'Status', {defaultValue: StatusDtoEnum.Inserted})}
                        ${getXmlLine(el, 'IdFPA', {defaultValue: 0})}
                        ${getXmlLine(el, 'IdPlanAnalytique')}
                        ${getXmlLine(el, 'IdSectionAnalytique')}
                    </d4p1:${tagNameDto}>`;
        }).join('');
    };

    return arrayEmpty(ListeSectionAnalytique?.[tagNameDto]) ? ''
        : ` <d4p1:${parentTagName}>${list(ListeSectionAnalytique[tagNameDto])}</d4p1:${parentTagName}>`;
}

function critereSaveActiviteXml(CritereSaveActivite: CriteresActiviteDtoInput): string {
    return ` <d4p1:CritereSaveActivite>
                <d4p1:Status>INSERTED</d4p1:Status>
                ${getXmlBoolean(CritereSaveActivite, 'FiltrerElementsClotures', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'IsTVA', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'RedescendreParametrageCompteurPoint', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'RedescendreParametrageRegles', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'ReglesSent', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeActiviteForRedescenteRegle', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeCEDelegationProprietaire', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeCommission', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeCompteFraisPortHA', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeCompteFraisPortVente', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeCompteTropPercu', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeCptAcompteCollectif', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeCptCollectif', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeDelegationEnveloppe', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeEnvImpActivite', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeFamProd', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeFamille', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeForPaiMoy', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeForParamFPA', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeForSaveActivite', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeJournal3', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeJournalAchat', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeJournalVente', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeListeActiviteCompteBancaire', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeListeCEDelegation', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeListePointVente', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'TakeTypeActivite', {defaultValue: false})}
                ${getXmlBoolean(CritereSaveActivite, 'WithEnveloppe', {defaultValue: false})}
              </d4p1:CritereSaveActivite>`;
}

function activiteXml(activity): string {
    const activityRef = guid();
    const enveloppeRef = guid();
    const isCreate = !activity.Id;
    return `<d4p1:Activite z:Id="i${activityRef}">
                ${getXmlLine(activity, 'Status')}
                ${getXmlBoolean(activity, 'AfficherMention', {defaultValue: false})}
                ${getXmlBoolean(activity, 'AutoriserAvoirAutreActivite', {defaultValue: false})}
                ${getXmlBoolean(activity, 'AutoriserPaiementDiffereDirecto', {defaultValue: false})}
                ${getXmlBoolean(activity, 'AutoriserPaiementDiffereGestion', {defaultValue: false})}
                ${ceDelegationProprietaireXml(activity.CEDelegationProprietaire)}
                ${getXmlLine(activity, 'Code')}
                ${commissionXml(activity.Commission)}
                ${compteXml(activity.CompteCollectifAcompteClient, 'CompteCollectifAcompteClient')}
                ${compteXml(activity.CompteCollectifAcompteFour, 'CompteCollectifAcompteFour')}
                ${compteCollectifClientXml(activity.CompteCollectifClient)}
                ${compteXml(activity.CompteCollectifFourniseur, 'CompteCollectifFourniseur')}
                ${compteXml(activity.CompteFraisPortAchat, 'CompteFraisPortAchat')}
                ${compteXml(activity.CompteFraisPortVente, 'CompteFraisPortVente')}
                ${compteXml(activity.CptTropPercu, 'CptTropPercu')}
                ${enveloppeXml(activity.Enveloppe, enveloppeRef)}
                ${imageXml(activity.FichierVenteGen, 'FichierVenteGen')}
                ${getXmlLine(activity, 'Id', {defaultValue: 0})}
                ${getXmlBoolean(activity, 'IdcDirectoVisible', {defaultValue: false})}
                ${imageXml(activity.ImageActivite, 'ImageActivite')}
                ${getXmlBoolean(activity, 'IsActivitePrivee', {defaultValue: false})}
                ${getXmlBoolean(activity, 'IsCloture', {defaultValue: false})}
                ${getXmlBoolean(activity, 'IsFacturationCentralise', {defaultValue: false})}
                ${getXmlBoolean(activity, 'IsTVA', {defaultValue: false})}
                ${journalXml(activity.Journal3, 'Journal3')}
                ${journalXml(activity.JournalAchat, 'JournalAchat')}
                ${journalXml(activity.JournalVente, 'JournalVente')}
                ${getXmlLine(activity, 'Libelle')}
                ${listeActiviteCompteBancaireXml(activity.ListeActiviteCompteBancaire)}
                ${listeCEDelegationXml(activity.ListeCEDelegation?.CEDelegationDTO, activity.CEDelegationProprietaire)}
                ${listeCompteursPointsXml(activity.ListeCompteursPoints?.CompteurPointAFPAModel)}
                ${listeEnvImpActiviteXml(activity.ListeEnvImpActivite?.EnvImpActiviteDTO, activityRef, enveloppeRef)}
                ${listeMoyenPaiementActiviteXml(activity.ListeMoyenPaiementActivite, activityRef, isCreate)}
                ${listePVXml(activity.ListePV?.PointVenteDTO)}
                ${getXmlLine(activity, 'MentionLegale')}
                ${getXmlLine(activity, 'NBChoix', {defaultValue: 0})}
                ${getXmlLine(activity, 'PrestaLibelleCadeauxEnLigne')}
                ${getXmlLine(activity, 'PrestaLibellePACEnLigne')}
                ${getXmlLine(activity, 'PrestaLibelleRemboursementEnLigne')}
                ${getXmlLine(activity, 'PrestaLibelleRmbMensuelEnLigne')}
                ${typeActiviteXml(activity.TypeActivite)}
             </d4p1:Activite>`;
}

function listeEnvImpActiviteXml(ListeEnvImpActivite: CeDelegationDtoInput[], activityRef: string, enveloppeRef: string): string {
    const list = (ListeEnvImpActivite: CeDelegationDtoInput[]): string => {
        return ListeEnvImpActivite.map(e => {
            return ` <d4p1:EnvImpActiviteDTO>
                        <d4p1:Status>INSERTED</d4p1:Status>
                        <d4p1:Activite z:Ref="i${activityRef}"></d4p1:Activite>
                        <d4p1:Enveloppe z:Ref="i${enveloppeRef}"></d4p1:Enveloppe>
                        ${getXmlLine(e, 'Id')}
                        ${getXmlBoolean(e, 'IsHerite', {defaultValue: false})}
                        ${getXmlBoolean(e, 'IsTransverse', {defaultValue: false})}
                     </d4p1:EnvImpActiviteDTO>`;
        }).join('');
    };

    return arrayEmpty(ListeEnvImpActivite) ? ''
        : ` <d4p1:ListeEnvImpActivite>${list(ListeEnvImpActivite)}</d4p1:ListeEnvImpActivite>`;
}

function listeActiviteCompteBancaireXml(ListeActiviteCompteBancaire: ArrayOfActiviteCompteBancaireDtoInput): string {
    const list = (ListeActiviteCompteBancaire: ActiviteCompteBancaireDtoInput[]): string => {
        return ListeActiviteCompteBancaire.map(e => {
            return `<d4p1:ActiviteCompteBancaireDTO>
                    <d4p1:Status>INSERTED</d4p1:Status>
                    <d4p1:ActiviteCompteBancaireType>
                        ${getXmlLine(e.ActiviteCompteBancaireType, 'Code')}
                        ${getXmlLine(e.ActiviteCompteBancaireType, 'Id')}
                        ${getXmlLine(e.ActiviteCompteBancaireType, 'Libelle')}
                    </d4p1:ActiviteCompteBancaireType>
                    ${getXmlLine(e, 'Id')}
                 </d4p1:ActiviteCompteBancaireDTO>`;
        }).join('');
    };

    return arrayEmpty(ListeActiviteCompteBancaire?.ActiviteCompteBancaireDTO) ? ''
        : ` <d4p1:ListeActiviteCompteBancaire>${list(ListeActiviteCompteBancaire.ActiviteCompteBancaireDTO)}</d4p1:ListeActiviteCompteBancaire>`;
}

function ceDelegationXml(CEDelegation: CeDelegationDtoInput, name = 'CEDelegation', zId = false): string {
    const zIdAttribut = !zId ? '' : ` z:Id="icedelegation${CEDelegation.Id}"`;
    return !CEDelegation ? ''
        : ` <d4p1:${name}${zIdAttribut}>${getXmlLine(CEDelegation, 'Id')} </d4p1:${name}>  `;
}

function enveloppeXml(Enveloppe: EnveloppeQuotaDtoInput, enveloppeRef: string): string {
    return !Enveloppe ? ''
        : ` <d4p1:Enveloppe z:Id="i${enveloppeRef}">
                ${getXmlLine(Enveloppe, 'Status')}
                ${ceDelegationXml(Enveloppe.CEDelegation)}
                ${getXmlLine(Enveloppe, 'Code')}
                ${getXmlLine(Enveloppe, 'Id', {defaultValue: 0})}
                ${getXmlBoolean(Enveloppe, 'IsCloture', {defaultValue: false})}
                ${getXmlBoolean(Enveloppe, 'IsComplementaire', {defaultValue: false})}
                ${getXmlBoolean(Enveloppe, 'IsEnvAttribution', {defaultValue: false})}
                ${getXmlBoolean(Enveloppe, 'IsSubChoisie', {defaultValue: false})}
                ${getXmlBoolean(Enveloppe, 'IsTransverse', {defaultValue: false})}
                ${getXmlLine(Enveloppe, 'Libelle')}
             </d4p1:Enveloppe>`;
}

function typeJournalXml(TypeJournal: JournalTypeDtoInput): string {
    return !TypeJournal ? ''
        : `<d4p1:TypeJournal>
            ${getXmlLine(TypeJournal, 'Code')}
            ${getXmlLine(TypeJournal, 'Description')}
            ${getXmlLine(TypeJournal, 'Id')}
            ${getXmlLine(TypeJournal, 'Libelle')}
        </d4p1:TypeJournal>`;
}

function journalXml(Journal: JournalDtoInput, tagName: string): string {
    return !Journal ? ''
        : `<d4p1:${tagName}>
                ${getXmlLine(Journal, 'Code')}
                ${getXmlBoolean(Journal, 'HasEcriture', {defaultValue: false})}
                ${getXmlLine(Journal, 'Id')}
                ${getXmlLine(Journal, 'IdJournalType', {defaultValue: 0})}
                ${getXmlBoolean(Journal, 'IsSupprime', {defaultValue: false})}
                ${getXmlLine(Journal, 'Libelle')}
                ${getXmlBoolean(Journal, 'NotHasEcriture', {defaultValue: false})}
                ${getXmlLine(Journal, 'TypeBudget')}
                ${typeJournalXml(Journal.TypeJournal)}
            </d4p1:${tagName}>`;
}

function compteCollectifClientXml(CompteCollectifClient: CompteDto): string {
    return `<d4p1:CompteCollectifClient>
                ${getXmlBoolean(CompteCollectifClient, 'AccepteLettrage', {defaultValue: false})}
                ${getXmlLine(CompteCollectifClient, 'Code')}
                ${getXmlBoolean(CompteCollectifClient, 'FonctionneCredit', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'FonctionneDebit', {defaultValue: false})}
                ${getXmlLine(CompteCollectifClient, 'IDFournisseur', {defaultValue: 0})}
                ${getXmlLine(CompteCollectifClient, 'Id')}
                ${getXmlLine(CompteCollectifClient, 'IdCptSection')}
                ${getXmlBoolean(CompteCollectifClient, 'IsAgregateur', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsBloque', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCentralisateur', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsClos', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCollectifAcompteClient', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCollectifAcompteFour', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCollectifClient', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCollectifCompteCourantFournisseur', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCollectifFournisseur', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCollectifMoyenPaiement', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCollectifPVMClient', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsCollectifPret', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsFonctionnement', {defaultValue: false})}
                ${getXmlBoolean(CompteCollectifClient, 'IsSocial', {defaultValue: false})}
                ${getXmlLine(CompteCollectifClient, 'Libelle')}
                ${getXmlLine(CompteCollectifClient, 'Numero')}
            </d4p1:CompteCollectifClient>`;
}

function compteXml(Compte: CompteDtoInput, tagName: string): string {
    return !Compte ? ''
        : `<d4p1:${tagName}>
                ${getXmlBoolean(Compte, 'AccepteLettrage', {defaultValue: false})}
                ${getXmlLine(Compte, 'Code')}
                ${getXmlBoolean(Compte, 'FonctionneCredit', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'FonctionneDebit', {defaultValue: false})}
                ${getXmlLine(Compte, 'IDFournisseur', {defaultValue: 0})}
                ${getXmlLine(Compte, 'Id')}
                ${getXmlLine(Compte, 'IdCptSection')}
                ${getXmlBoolean(Compte, 'IsAgregateur', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsBloque', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCentralisateur', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsClos', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCollectifAcompteClient', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCollectifAcompteFour', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCollectifClient', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCollectifCompteCourantFournisseur', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCollectifFournisseur', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCollectifMoyenPaiement', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCollectifPVMClient', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsCollectifPret', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsFonctionnement', {defaultValue: false})}
                ${getXmlBoolean(Compte, 'IsSocial', {defaultValue: false})}
                ${getXmlLine(Compte, 'Libelle')}
                ${getXmlLine(Compte, 'Numero')}
            </d4p1:${tagName}>`;
}

function ceDelegationProprietaireXml(CEDelegationProprietaire: CeDelegationDtoInput): string {
    return !CEDelegationProprietaire ? ''
        : `${ceDelegationXml(CEDelegationProprietaire, 'CEDelegationProprietaire', true)}`;
}

function commissionXml(Commission: CommissionDtoInput): string {
    return `<d4p1:Commission>
            ${getXmlLine(Commission, 'Code')}
            ${getXmlLine(Commission, 'Id')}
            ${getXmlBoolean(Commission, 'IsClos', {defaultValue: false})}
            ${getXmlBoolean(Commission, 'IsSelected', {defaultValue: false})}
            ${getXmlLine(Commission, 'Libelle')}
         </d4p1:Commission>`;
}

function typeActiviteXml(TypeActivite: TypeActiviteDtoInput): string {
    return `<d4p1:TypeActivite>
            ${getXmlLine(TypeActivite, 'Code')}
            ${getXmlLine(TypeActivite, 'CodeMod')}
            ${getXmlLine(TypeActivite, 'Comportement')}
            ${getXmlLine(TypeActivite, 'DirectoModule')}
            ${getXmlLine(TypeActivite, 'Id')}
            ${getXmlBoolean(TypeActivite, 'IsDisponiblePortail')}
            ${getXmlLine(TypeActivite, 'Libelle')}
            ${getXmlLine(TypeActivite, 'Ordre')}
         </d4p1:TypeActivite>`;
}

function listePVXml(PointVenteDTO: PointVenteDtoInput[]): string {
    const list = (PointVenteDTO: PointVenteDtoInput[]): string => {
        return PointVenteDTO.map(c => {
            return `<d4p1:PointVenteDTO>
                        ${getXmlLine(c, 'ID')}
                        ${getXmlLine(c, 'PVCodl')}
                        ${getXmlBoolean(c, 'PVIDCclo', {defaultValue: false})}
                        ${getXmlLine(c, 'PVLib')}
                        ${getXmlBoolean(c, 'PVUseAdrGlo', {defaultValue: false})}
                     </d4p1:PointVenteDTO>`;
        }).join('');
    };

    return arrayEmpty(PointVenteDTO) ? ''
        : ` <d4p1:ListePV>${list(PointVenteDTO)}</d4p1:ListePV>`;
}

function imageXml(Image: FichierModelInput, name: string): string {
    return ` <d4p1:${name}>
          ${getXmlLine(Image, 'Status', {defaultValue: StatusDtoEnum.Inserted})}
          ${getXmlLine(Image, 'Extension')}
          ${getXmlLine(Image, 'FileBytes')}
          ${getXmlLine(Image, 'Filename')}
          ${getXmlLine(Image, 'IdFile')}
          ${getXmlBoolean(Image, 'IsFichierClient', {defaultValue: false})}
          ${getXmlLine(Image, 'LibelleLien')}
          ${getXmlLine(Image, 'Taille', {defaultValue: 0})}
          ${getXmlLine(Image, 'Token')}
          ${getXmlLine(Image, 'Url')}
        </d4p1:${name}>`;
}

function listeCompteursPointsXml(CompteurPointAFPAModel: CompteurPointAfpaModelInput[]): string {
    const list = (CompteurPointAFPAModel: CompteurPointAfpaModelInput[]): string => {
        return CompteurPointAFPAModel.map(c => {
            return `<d4p1:CompteurPointAFPAModel z:Id="i${guid()}">
                        ${getXmlLine(c, 'Code')}
                        ${getXmlLine(c, 'IdAFPA')}
                        ${getXmlLine(c, 'IdCompteur')}
                        ${getXmlBoolean(c, 'IsDeleted', {defaultValue: false})}
                        ${getXmlBoolean(c, 'IsFromFirstEuro', {defaultValue: false})}
                        ${getXmlLine(c, 'Libelle')}
                        ${getXmlLine(c, 'MontantSub')}
                        ${getXmlLine(c, 'Valeur')}
                     </d4p1:CompteurPointAFPAModel>`;
        }).join('');
    };
    return arrayEmpty(CompteurPointAFPAModel) ? ''
        : ` <d4p1:ListeCompteursPoints>${list(CompteurPointAFPAModel)}</d4p1:ListeCompteursPoints>`;
}

function listeMoyenPaiementActiviteXml(ListeMoyenPaiementActivite: ArrayOfMoyenPaiementActiviteDtoInput, activityRef: string, isCreate: boolean): string {
    const list = (ListeMoyenPaiementActivite: MoyenPaiementActiviteDtoInput[]): string => {
        return ListeMoyenPaiementActivite.map(paymentMethod => {
                let mp = cloneDeep(paymentMethod);
                mp.Status = isCreate ? StatusDtoEnum.Inserted : StatusDtoEnum.Updated;
                return `<d4p1:MoyenPaiementActiviteDTO>
                             ${getXmlLine(mp, 'Status')}
                             <d4p1:Activite z:Ref="i${activityRef}"></d4p1:Activite>
                             ${getXmlBoolean(mp, 'CanUseModeleEcheancier', {defaultValue: false})}
                             ${getXmlBoolean(mp, 'HaveModeleEcheancierParametre', {defaultValue: false})}
                             ${getXmlBoolean(mp, 'IsUseAchat', {defaultValue: false})}
                             ${getXmlBoolean(mp, 'IsUseDirecto', {defaultValue: false})}
                             ${getXmlBoolean(mp, 'IsUseVente', {defaultValue: false})}
                             <d4p1:MoyenPaiement>
                                    ${getXmlLine(mp.MoyenPaiement, 'Code')}
                                    ${getXmlLine(mp.MoyenPaiement, 'Id')}
                                    ${getXmlLine(mp.MoyenPaiement, 'Libelle')}
                                    <d4p1:TypeMoyenPaiement>
                                        ${getXmlLine(mp.MoyenPaiement.TypeMoyenPaiement, 'Code')}
                                        ${getXmlLine(mp.MoyenPaiement.TypeMoyenPaiement, 'Id')}
                                        ${getXmlLine(mp.MoyenPaiement.TypeMoyenPaiement, 'Libelle')}
                                   </d4p1:TypeMoyenPaiement>
                             </d4p1:MoyenPaiement>
                         </d4p1:MoyenPaiementActiviteDTO>`;
            }
        ).join('');
    };

    return arrayEmpty(ListeMoyenPaiementActivite?.MoyenPaiementActiviteDTO) ? ''
        : `<d4p1:ListeMoyenPaiementActivite>${list(ListeMoyenPaiementActivite?.MoyenPaiementActiviteDTO)}</d4p1:ListeMoyenPaiementActivite>`;
}
